<div class="absolute inset-0 flex items-center justify-center bg-black/25">
  <mat-spinner
    mode="indeterminate"
    color="accent"
    diameter="40"
    strokeWidth="4">
  </mat-spinner>
</div>